import { gql, MutationTuple, useMutation } from '@apollo/client';

export const UPDATE_STUDENT_LEANING_PATH_STATUS = gql`
  mutation UpdateStudentLearningPathwayStatus(
    $studentId: NonEmptyString!
    $pathwayId: NonEmptyString!
    $completed: Boolean!
  ) {
    updateStudentLearningPathwayStatus(studentId: $studentId, pathwayId: $pathwayId, completed: $completed)
  }
`;

export const UPDATE_STUDENT_LEANING_PATH_MATCH = gql`
  mutation UpdateSkillMatchByPathwayIdAndStudentId(
    $studentId: NonEmptyString!
    $pathwayId: NonEmptyString!
    $skillMatchPercentage: Float!
  ) {
    updateSkillMatchByPathwayIdAndStudentId(
      studentId: $studentId
      pathwayId: $pathwayId
      skillMatchPercentage: $skillMatchPercentage
    )
  }
`;

interface IUpdateStudentLearningPathwayStatusParams {
  studentId: string;
  pathwayId: string;
  completed?: boolean;
  skillMatchPercentage?: number;
}

interface IUpdateStudentLearningPathwayStatusResponse {
  updateStudentLearningPathwayStatus: boolean;
}

interface IUpdateStudentLearningPathMatchResponse {
  updateSkillMatchByPathwayIdAndStudentId: boolean;
}

export const useUpdateStudentLearningPathStatus = (): MutationTuple<
  IUpdateStudentLearningPathwayStatusResponse,
  IUpdateStudentLearningPathwayStatusParams
> =>
  useMutation<IUpdateStudentLearningPathwayStatusResponse, IUpdateStudentLearningPathwayStatusParams>(
    UPDATE_STUDENT_LEANING_PATH_STATUS,
  );

export const useUpdateStudentLearningPathMatch = (): MutationTuple<
  IUpdateStudentLearningPathMatchResponse,
  IUpdateStudentLearningPathwayStatusParams
> =>
  useMutation<IUpdateStudentLearningPathMatchResponse, IUpdateStudentLearningPathwayStatusParams>(
    UPDATE_STUDENT_LEANING_PATH_MATCH,
  );
